import { HpError } from '@hprofits/shared/errors';

export type ErrorWithDetails<T extends Record<string, unknown> = Record<string, unknown>> = HpError &
  Readonly<{
    details?: T;
  }>;

export const isErrorWithDetails = (error: HpError): error is ErrorWithDetails<Record<string, unknown>> => {
  return 'details' in error;
};
